<template>
  <v-container>
    <v-layout row>
      <v-flex xs10 md7 offset-md2 pb-3>
        <v-btn flat class="primary" router @click="back">
          <v-icon>arrow_back</v-icon>
        </v-btn>
      </v-flex>
      <v-flex mt-1 v-if="isUserAdmin && !isFinished">
        <ModifyCourse v-bind:courseID="courseID" />
      </v-flex>
    </v-layout>
    <v-layout row wrap v-if="!loaded">
      <v-flex offset-xs5 offset-sm6 pt-5>
        <v-progress-circular :size="70" :width="7" color="light-blue darken-4" indeterminate></v-progress-circular>
      </v-flex>
    </v-layout>
    <v-flex xs12 sm8 offset-sm2>
      <v-card class="cardText cardBackground" v-if="loaded">
        <v-card-title primary-title>
          <v-layout row wrap>
            <v-flex xs12>
              <div pb-3 class="headline">{{ course.course_name }}</div>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-flex md6 offset-md1 mb-4>
            <div>
              <span class="courseElement">Dal:</span>
              {{course.startDate | dateFilter}}
              <span class="courseElement">al:</span>
              {{course.finishDate | dateFilter}}
            </div>
            <div>
              <span class="courseElement">Dalle:</span>
              {{course.time_start}}
              <span class="courseElement">alle:</span>
              {{ course.time_finish}}
            </div>
            <div>
              <span class="courseElement">Posti Occupati:</span>
              {{course.occupied_places}} / {{course.course_places}}
            </div>
            <div>
              <span class="courseElement">Svolgimento Corso:</span>
              {{course.description}}
            </div>
          </v-flex>
          <v-flex md6 offset-md1 mb-1>
            <div>{{descrizione}}</div>
          </v-flex>

          <v-flex md6 offset-md1 mb-1 mt-3>
            <div>
              <span class="courseElement">Note Aggiuntive:</span>
              {{course.note}}
            </div>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-layout row wrap v-if="isAuthorized">
            <v-flex xs3 v-if="!isFinished">
              <v-btn
                flat
                class="cardText"
                @click="signToCourse(courseID)"
                v-if="!isRegistered"
              >Iscriviti</v-btn>
              <v-btn
                flat
                class="cardText"
                @click="unsignToCourse(courseID)"
                v-if="isRegistered"
              >Annulla Iscrizione</v-btn>
            </v-flex>

            <v-spacer></v-spacer>
            <span v-if="isUserAdmin">
              <v-btn
                flat
                small
                class="cardText"
                v-if="!isFinished"
                router
                :to="'/courses/' + courseID + '/usersList'"
              >
                <v-icon>people_outline</v-icon>
              </v-btn>
              <v-btn
                flat
                small
                class="cardText"
                router
                :to="'/courses/' + courseID + '/registeredUsers'"
              >
                <v-icon>list_alt</v-icon>
              </v-btn>
              <v-btn flat small class="cardText" @click="deleteCourse(courseID)">
                <v-icon>delete</v-icon>
              </v-btn>
            </span>
          </v-layout>
          <v-layout row wrap v-if="!isAuthorized">
            <v-flex xs12>
              <p
                class="athorizationError"
              >Impossibile iscriversi al corso finchè non verrà conferita l'autorizzazione dall'amministratore</p>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-container>
</template>

<script>
import { bus } from "../main";
import { db } from "../main";
import ModifyCourse from "../components/ModifyCourseDialog.vue";
export default {
  components: { ModifyCourse },
  data: () => ({
    course: {
      course_name: "",
      course_places: 0,
      occupied_places: 0,
      time_start: null,
      time_finish: null,
      startDate: null,
      finishDate: null,
      note: "",
      description: "",
      status: ""
    },
    descrizione: "",
    courseID: "",
    loaded: false,
    modified: false
  }),
  computed: {
    //controlla se l'utente è registrato al corso
    isRegistered() {
      let registeredCourses = this.$store.getters.getRegisteredCourses;
      let flag = false;
      if (registeredCourses !== null) {
        registeredCourses.forEach(course => {
          if (course === this.courseID) {
            flag = true;
          }
        });
      }
      return flag;
    },

    //controlla se l'utente è admin
    isUserAdmin() {
      return this.$store.getters.getRole === "Admin";
    },

    //controlla se il corso è finito
    isFinished() {
      var course = this.$store.getters.getCourse;
      var courseStatus = "";
      if (course !== null) {
        courseStatus = course.status;
      }
      return courseStatus === "Terminato";
    },
    //controlla se l'utente è stato autorizzato dall'admin
    isAuthorized() {
      return this.$store.getters.getAuthorized === "1";
    }
  },

  methods: {
    //metodo per il recupero delle info riguardanti il corso selezionato
    listener() {
      let type = "";
      const course = this.$store.getters.getCourse;
      this.courseID = course.id;
      db.collection("corsi")
        .doc(this.courseID)
        .get()
        .then(doc => {
          type = doc.data().id_tipo_corso;
          this.course.course_name = doc.data().nome;
          this.course.course_places = doc.data().posti_tot;
          this.course.occupied_places = doc.data().posti_occupati;
          this.course.description = doc.data().descrizione_svolgimento;
          this.course.time_start = doc.data().ora_inizio;
          this.course.time_finish = doc.data().ora_fine;
          this.course.startDate = doc.data().data_inizio;
          this.course.finishDate = doc.data().data_fine;
          this.course.note = doc.data().note;
          db.collection("tipi_corso")
            .doc(type)
            .get()
            .then(elem => {
              this.descrizione = elem.data().descrizione;
              this.loaded = true;
            })
            .catch(error => {
              bus.$emit(
                "errorOperation",
                "Errore: problema nel caricamento della descrizione del corso(" +
                  error +
                  ")"
              );
            });
        });
    },
    //metodo per la cancellazione di un corso ed eliminazione dei record di quest'ultimo dalla tabella "iscritti"
    deleteCourse(courseID) {
      if (confirm("Eliminare Corso?")) {
        db.collection("corsi")
          .doc(courseID)
          .delete()
          .then(() => {
            db.collection("iscritti")
              .get()
              .then(list => {
                list.forEach(element => {
                  if (element.data().id_corso === courseID) {
                    db.collection("iscritti")
                      .doc(element.id)
                      .delete()
                      .catch(error => {
                        bus.$emit(
                          "errorOperation",
                          "Errore: problema nella cancellazione del corso(" +
                            error +
                            ")"
                        );
                      });
                  }
                });
                this.$router.push("/courses");
                bus.$emit(
                  "successfullOperation",
                  "Corso eliminato con successo"
                );
              })
              .catch(error => {
                bus.$emit(
                  "errorOperation",
                  "Errore: problema nella cancellazione del corso(" +
                    error +
                    ")"
                );
              });
          })
          .catch(error => {
            bus.$emit(
              "errorOperation",
              "Errore: problema nella cancellazione del corso(" + error + ")"
            );
          });
      }
    },

    //metodo per l'iscrizione al corso(crea un record in "iscritti" e aggiorna l'array locale per i corsi a cui l'utente è iscritto)
    signToCourse(courseID) {
      var registered = this.$store.getters.getRegisteredCourses;
      var count = 0;
      db.collection("corsi")
        .doc(courseID)
        .get()
        .then(doc => {
          if (doc.data().posti_occupati + 1 <= doc.data().posti_tot) {
            let user = this.$store.getters.getUserLoged;
            let userID = user.uid;
            const iscrizioni = {
              id_corso: courseID,
              id_utente: userID
            };
            db.collection("iscritti")
              .doc()
              .set(iscrizioni)
              .then(() => {
                db.collection("iscritti")
                  .where("id_corso", "==", courseID)
                  .get()
                  .then(list => {
                    list.forEach(element => {
                      if (element.data().id_corso === courseID) {
                        count++;
                      }
                    });
                    db.collection("corsi")
                      .doc(courseID)
                      .update({
                        posti_occupati: count
                      })
                      .then(() => {
                        this.listener();
                        registered.push(courseID);
                        this.$store.dispatch(
                          "setRegisteredCourses",
                          registered
                        );
                        bus.$emit(
                          "successfullOperation",
                          "Iscrizione avvenuta con successo"
                        );
                      })
                      .catch(error => {
                        bus.$emit(
                          "errorOperation",
                          "Errore: problema nell'aggiornamento dei partecipanti al corso(" +
                            error +
                            ")"
                        );
                      });
                  })
                  .catch(error => {
                    bus.$emit(
                      "errorOperation",
                      "Errore: problema nell'aggiornamento dei partecipanti al corso(" +
                        error +
                        ")"
                    );
                  });
              })
              .catch(error => {
                bus.$emit(
                  "errorOperation",
                  "Errore: problema nella registrazione al corso(" + error + ")"
                );
              });
          } else {
            bus.$emit("errorOperation", "Corso al completo");
          }
        })
        .catch(error => {
          bus.$emit(
            "errorOperation",
            "Errore: problema nella registrazione al corso(" + error + ")"
          );
        });
    },

    //disiscrizione dell'utente da un corso(elimina un record in "iscritti" e aggiorna l'array locale per i corsi a cui l'utente è iscritto )
    unsignToCourse(courseID) {
      var count = 0;
      var courseLocalIndex = 0; //indice del corso nell'array locale contenente i corsi a cui l'utente è iscritto
      let registeredCourses = this.$store.getters.getRegisteredCourses;
      let user = this.$store.getters.getUserLoged;
      let userID = user.uid;
      db.collection("iscritti")
        .where("id_utente", "==", userID)
        .get()
        .then(list => {
          list.forEach(element => {
            if (
              element.data().id_corso === courseID &&
              element.data().id_utente === userID
            ) {
              db.collection("iscritti")
                .doc(element.id)
                .delete()
                .then(() => {
                  db.collection("iscritti")
                    .where("id_corso", "==", courseID)
                    .get()
                    .then(list => {
                      list.forEach(element => {
                        if (element.data().id_corso === courseID) {
                          count++;
                        }
                      });
                      db.collection("corsi")
                        .doc(courseID)
                        .update({
                          posti_occupati: count
                        })
                        .then(() => {
                          this.listener();
                          courseLocalIndex = registeredCourses.indexOf(
                            courseID
                          );
                          if (courseLocalIndex > -1) {
                            registeredCourses.splice(courseLocalIndex, 1);
                          }
                          this.$store.dispatch(
                            "setRegisteredCourses",
                            registeredCourses
                          );

                          bus.$emit(
                            "successfullOperation",
                            "Iscrizione annullata con successo"
                          );
                        })
                        .catch(error => {
                          bus.$emit(
                            "errorOperation",
                            "Errore: problema nell'aggiornamento dei partecipanti al corso(" +
                              error +
                              ")"
                          );
                        });
                    })
                    .catch(error => {
                      bus.$emit(
                        "errorOperation",
                        "Errore: problema nell'aggiornamento dei partecipanti al corso(" +
                          error +
                          ")"
                      );
                    });
                })
                .catch(error => {
                  bus.$emit(
                    "errorOperation",
                    "Errore: problema nella disiscrizione dell'utente dal corso(" +
                      error +
                      ")"
                  );
                });
            }
          });
        })
        .catch(error => {
          bus.$emit(
            "errorOperation",
            "Errore: problema nella disiscrizione dell'utente dal corso(" +
              error +
              ")"
          );
        });
    },
    //metodo per far tornare l'utente alla pagina precedente a quella attuale
    back() {
      window.history.back();
    }
  },

  //invocazione del metodo per l'inizializzazione delle info sul corso alla creazione della pagina e alla modifica di questa
  created() {
    this.listener();
    bus.$on("modified", data => {
      // this.modified = data;
      if (data === true) {
        this.listener();
      }
    });
  }
};
</script>

